import { AppBar } from "@features/dashboard/layouts/AppBar";
import { LessonsExploreScreen } from "@memorang/ui/components/LessonsExploreScreen/LessonsExploreScreen";
import { useRouter } from "expo-router";
import { useLessonsExplore } from "../hooks/useLessonsExplore";

export const LessonsExploreContainer = () => {
	const router = useRouter();
	const explore = useLessonsExplore();

	const handleLessonPress = ({ id }: { id: string }) => {
		router.push(`/modules/${id}`);
	};

	return (
		<>
			<AppBar title="Modules" />
			<LessonsExploreScreen
				sortModalTitle="Sort modules"
				searchQuery={explore.searchQuery}
				onChangeSearch={explore.onChangeSearch}
				filterState={explore.filterState}
				onToggleFilter={explore.onToggleFilter}
				sections={explore.sections}
				totalLessons={explore.totalLessons}
				onLessonPress={handleLessonPress}
				sortType={explore.sortType}
				sortOrder={explore.sortOrder}
				onSelectSort={explore.onSelectSort}
				topicFilters={explore.topicFilters}
				onApplyTopicFilters={explore.onApplyTopicFilters}
				onClearFilters={explore.onClearFilters}
			/>
		</>
	);
};
